var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgXClose = function SvgXClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.282 3.218a.756.756 0 0 0-1.063 0 .754.754 0 0 0 0 1.062L8.938 10l-5.719 5.719a.75.75 0 0 0 1.06 1.06l5.718-5.72 5.722 5.722a.75.75 0 0 0 1.06-1.06l-5.72-5.718 5.723-5.722a.75.75 0 0 0-1.06-1.06l-5.718 5.72z"
  })));
};
export default SvgXClose;